"use strict";

var _typeof = require("/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cleanEventData = cleanEventData;
exports.extractUTParameters = extractUTParameters;
exports.getPageViewedEventProperties = getPageViewedEventProperties;
exports.prepareEventProperties = prepareEventProperties;
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var UTM_TO_AMP_PROP = {
  utm_adgroup: 'utmAdGroup',
  utm_bu: 'utmBu',
  utm_network: 'utmNetwork',
  ut_source: 'upgradeTriggerSource',
  ut_source2: 'upgradeTriggerSource2',
  ut_source3: 'upgradeTriggerSource3'
};

/**
 * Extracts certain UT parameters from the current URL and returns them
 * formatted for Amplitude event properties
 *
 * @returns A dictionary of the extracted parameters
 */
function extractUTParameters() {
  var retVal = {};

  // Extract ut params and add them to eventData
  var urlParams = new URL(window.location.href).searchParams;
  Object.keys(UTM_TO_AMP_PROP).forEach(function (key) {
    if (urlParams.has(key)) {
      retVal[UTM_TO_AMP_PROP[key]] = urlParams.get(key);
    }
  });
  return retVal;
}

/**
 * Removes @sm/metrics specific properties from event data
 *
 * @param eventData The event properties dictionary
 * @returns A shallow copy of the event data provided with some keys removed
 */
function cleanEventData(eventData) {
  var retVal = _objectSpread({}, eventData) || {};

  // remove values we don't want to pass along as event properties
  delete retVal.amplitudeEvent;
  delete retVal.amplitudeUserProperties;
  delete retVal.actionType;
  delete retVal.actionFlow;
  delete retVal.disableDA;
  return retVal;
}

/**
 * Returns a dictionary of page viewed event properties for page viewed events
 *
 * @param eventName The name of the event being sent
 * @param eventData
 * @returns An empty dict if not a page viewed event, otherwise properties for a page viewed event
 */
function getPageViewedEventProperties(eventName) {
  var retVal = {};

  // we're only in the business of page view events
  if (eventName.indexOf('page viewed') > -1) {
    retVal = _objectSpread({
      urlPath: window.location.pathname,
      hostName: window.location.hostname
    }, extractUTParameters());
  }
  return retVal;
}

/**
 * Cleans and decorates the event properties for a given event
 *
 * @param eventName The name of the event to be sent
 * @param eventData The provided properties of the event
 * @returns Prepped dictionary of event properties
 */
function prepareEventProperties(eventName, eventData) {
  var retVal = cleanEventData(eventData);
  retVal = _objectSpread(_objectSpread({}, getPageViewedEventProperties(eventName)), retVal);
  return retVal;
}